import { FC, useEffect, useState } from 'react';

import { useWishList } from '@/hooks';
import { IconSvg, Link } from '@/components';

import style from './favoriteheader.module.scss';

interface FavoriteHeaderProps {
  showLabel?: boolean;
  label?: string;
}

const FavoriteHeader: FC<FavoriteHeaderProps> = ({
  label = 'Wishlist',
  showLabel,
}) => {
  const [favLength, setFavLength] = useState(0);
  const { favProductsIds } = useWishList();

  useEffect(() => {
    setFavLength(favProductsIds.length);
  }, [favProductsIds]);

  const wishlistLabel =
    favLength > 0
      ? `Go to wish list with ${favLength} ${
          favLength === 1 ? 'item' : 'items'
        }`
      : 'Go to wish list';

  return (
    <Link
      aria-label={wishlistLabel}
      className={style.fav__actions}
      href="/wishlist"
    >
      <IconSvg decorative={false} name={'favorite'} title={wishlistLabel} />
      {favLength > 0 && (
        <span aria-atomic="true" aria-live="polite" className={style.counter}>
          {favLength}
        </span>
      )}
      {showLabel && <span className={style.fav__actions_label}>{label}</span>}
    </Link>
  );
};
export default FavoriteHeader;
